/**
 * AI 分析 Hook
 * 使用后端 Gemini API 进行竞争分析
 */

import { useState } from 'react';
import { message } from 'antd';
import axios from 'axios';
import type { CompetitorData } from '../types';
import { buildPrompt } from '../utils';

const API_BASE_URL = 'http://localhost:8000/api';

export const useAiAnalysis = () => {
    const [aiAnalyzing, setAiAnalyzing] = useState(false);
    const [aiResult, setAiResult] = useState<string | null>(null);
    const [aiError, setAiError] = useState<string | null>(null);

    const handleAiAnalysis = async (data: CompetitorData | null) => {
        if (!data) return;

        setAiAnalyzing(true);
        setAiResult(null);
        setAiError(null);

        try {
            const prompt = buildPrompt(data);

            // 使用后端 AI 分析 API (Gemini)
            const response = await axios.post(`${API_BASE_URL}/ai/analysis/custom_analysis/`, {
                prompt: prompt,
                analysis_type: 'competitor_analysis',
            }, {
                timeout: 120000, // 2分钟超时
            });

            if (response.data?.result) {
                setAiResult(response.data.result);
            } else if (response.data?.error) {
                throw new Error(response.data.error);
            } else {
                throw new Error('API 返回格式异常');
            }
        } catch (error: any) {
            let errorMsg = 'AI分析失败';

            if (axios.isAxiosError(error)) {
                if (error.response?.data?.error) {
                    errorMsg = error.response.data.error;
                } else if (error.response?.data?.detail) {
                    errorMsg = error.response.data.detail;
                } else if (error.code === 'ECONNABORTED') {
                    errorMsg = '请求超时，请稍后重试';
                } else if (!error.response) {
                    errorMsg = '无法连接到服务器，请检查后端服务是否启动';
                }
            } else if (error.message) {
                errorMsg = error.message;
            }

            setAiError(errorMsg);
            message.error(errorMsg);
        } finally {
            setAiAnalyzing(false);
        }
    };

    return {
        aiAnalyzing,
        aiResult,
        aiError,
        handleAiAnalysis,
    };
};


